import { toRaw } from 'vue';

/**
 * Recursively unwrap Vue reactive proxies into plain values so Worker#postMessage
 * (structured clone) does not throw DataCloneError.
 */
export function toPlain<T>(value: T): T {
  const raw = toRaw(value as object) as T;

  if (raw === null || typeof raw !== 'object') {
    return raw;
  }

  if (raw instanceof Date || raw instanceof RegExp) {
    return raw;
  }

  if (Array.isArray(raw)) {
    return raw.map((item) => toPlain(item)) as T;
  }

  if (raw instanceof Map) {
    return new Map([...raw.entries()].map(([key, item]) => [toPlain(key), toPlain(item)])) as T;
  }

  if (raw instanceof Set) {
    return new Set([...raw.values()].map((item) => toPlain(item))) as T;
  }

  const result: Record<string, unknown> = {};
  for (const key of Object.keys(raw as object)) {
    result[key] = toPlain((raw as Record<string, unknown>)[key]);
  }

  return result as T;
}
